<div #creditReport class="report ifs-report">
  @if (showInquirySection) {
    <div>
      <h2>{{ 'content.inquiry' | translate }}</h2>
      @if (isReportAnyIfsProduct(['aml', 'eAml', 'avs', 'bvs', 'dirs', 'eDirs'])) {
        <div class="row">
          <div class="col-3">{{ 'content.person.name' | translate }}:</div>
          <div class="col-9">{{ nameOfPerson }}</div>
        </div>
      }
      @if (isReportAnyIfsProduct(['avs'])) {
        <div class="row">
          <div class="col-3">{{ 'content.credit-card' | translate }}:</div>
          <div class="col-9">{{ maskAccountNumber(ifsRequest?.avs?.creditCard) }}</div>
        </div>
      }
      @if (isReportAnyIfsProduct(['aml', 'eAml', 'bvs'])) {
        <div class="row">
          <div class="col-3">{{ 'content.social-insurance-number-short' | translate }}:</div>
          <div class="col-9">{{ maskSin(sin) }}</div>
        </div>
      }
      @if (isReportAnyIfsProduct(['avs'])) {
        <div class="row">
          <div class="col-3">{{ 'content.social-insurance-number-short' | translate }}:</div>
          <div class="col-9">{{ maskSin(ifsRequest?.avss?.sin) }}</div>
        </div>
      }
      @if (isReportAnyIfsProduct(['aml', 'eAml', 'avs', 'bvs'])) {
        <div class="row">
          <div class="col-3">{{ 'content.person.dob' | translate }}:</div>
          <div class="col-9">{{ reformatDate(ifs2?.dob) }}</div>
        </div>
      }
      @for (a of ifs2?.addresses; track a) {
        <div>
          @if (isReportAnyIfsProduct(['aml', 'eAml', 'avs', 'bvs', 'dirs', 'eDirs'])) {
            <div class="row">
              <div class="col-3">{{ 'content.address.address' | translate }}:</div>
              <div class="col-9">{{ a.line1 }}</div>
            </div>
          }
          @if (isReportAnyIfsProduct(['aml', 'eAml', 'avs', 'bvs', 'dirs', 'eDirs'])) {
            <div class="row">
              <div class="col-3"></div>
              <div class="col-9">{{ a.line2 }}</div>
            </div>
          }
        </div>
      }
      @if (isReportAnyIfsProduct(['aml', 'eAml', 'avs', 'bvs', 'dirsLookup', 'eDirs'])) {
        <div class="row">
          <div class="col-3">{{ 'content.telephone' | translate }}:</div>
          <div class="col-9">{{ reformatPhone(ifs2?.phone) }}</div>
        </div>
      }
      @if (isReportAnyIfsProduct(['hawk'])) {
        <div>
          @for (a of ifs2?.addresses; track a; let i = $index) {
            <div>
              <div class="row">
                <div class="col-3">{{ 'content.address.address' | translate }} {{ i }}:</div>
                <div class="col-9">{{ a.type }}</div>
              </div>
              <div class="row">
                <div class="col-3"></div>
                <div class="col-9">{{ a.line1 }}</div>
              </div>
              <div class="row">
                <div class="col-3"></div>
                <div class="col-9">{{ a.line2 }}</div>
              </div>
              <div class="row">
                <div class="col-3"></div>
                <div class="col-9">{{ a.line3 }}</div>
              </div>
            </div>
          }
          <div class="row">
            <div class="col-3">{{ 'content.joint-date-of-birth' | translate }}:</div>
            <div class="col-9">{{ reformatDate(ifs2?.dob) }}</div>
          </div>
        </div>
      }
    </div>
  }
  <!-- Consumer Statement -->
  @if (hasConsumerStatement()) {
    <div class="break-after-avoid">
      <h2>{{ 'content.consumer-statement' | translate }}</h2>
      <div class="d-none d-lg-flex row ps-0 pe-0">
        <h3 class="col-3">{{ 'content.date' | translate }}</h3>
        <h3 class="col-9">{{ 'content.information' | translate }}</h3>
      </div>
      @for (consumer of consumerRequestReport?.report?.consumers; track consumer) {
        <div>
          @for (consumerStatement of consumerStatemets(consumer.consumerStatement); track consumerStatement) {
            <div >
              <div class="row">
                <div class="col-3">{{ dayMonthYear(consumerStatement.date, 'DDMMYYYY') }}</div>
                <div class="col-9">
                  <div class="row">
                    <div class="col-12">{{ consumerStatement.type }} {{ consumerStatement.message }}</div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
  <!-- Credit Freeze -->
  @if (isCreditFreezeMessageExistsInIFSReport()) {
    <div>
      <h2>{{ 'content.credit-freeze' | translate }}</h2>
      <div>{{ifsReport.mi01OUT.message}}</div>
    </div>
  }

  @if (isCreditFreezeMessageExistsInConsumerReport()) {
    <div>
      <h2>{{ 'content.credit-freeze' | translate }}</h2>
      <div>{{getCreditFreezeMessageForConsumerReport()}}</div>
    </div>
  }

  <!-- EAML Dirs Content -->
  @if (enhancedDirectoryServices && !isCreditFreezeAndNonExemptedMCInConsumerReport()) {
    <div class="report-section">
      <h2>{{ 'content.aml-section' | translate }}</h2>
      <div class="row">
        <div class="col-3">{{ 'content.aml-bureau-match' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.amlBureauMatch }}</div>
            <div class="col-11">{{ amlBureauFlagTranslation(enhancedDirectoryServices.amlBureauMatch) | async }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.bureau-hit' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.creditBureauHit }}</div>
            <div class="col-11">{{ amlBureauHitFlagTranslation(enhancedDirectoryServices.creditBureauHit) | async }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.person.last-name' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.lnameMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.lnameMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.lastName)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.person.first-name' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.fnameMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.fnameMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.firstName)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.person.middle-name' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.mnameMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.mnameMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.middleName)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.address.street-name' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.streetNameMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.streetNameMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.street)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.address.civic' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.streetCivicMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.streetCivicMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.streetCivicNumber)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.address.apartment' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.aptMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.aptMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.apt)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.address.city-name' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.cityMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.cityMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.city)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.address.province' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.provMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.provMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.prov)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.address.postal' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.postalMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.postalMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.postalCode)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.telephone' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.phoneMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.phoneMatch) | async }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.person.dob' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.dobMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.dobMatch) | async }}{{noOrPartialMatch(enhancedDirectoryServices.dob)}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.social-insurance-number-short' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.sinMatch }}</div>
            <div class="col-11">{{ amlFlagTranslation(enhancedDirectoryServices.sinMatch) | async }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">{{ 'content.fraud-alert' | translate }}</div>
        <div class="col-9">
          <div class="row">
            <div class="col-1">{{ enhancedDirectoryServices.fraudFlag }}</div>
            <div class="col-11">{{ amlFraudFlagTranslation(enhancedDirectoryServices.fraudFlag) | async }}</div>
          </div>
        </div>
      </div>
    </div>
  }
  <!-- Dual Source Content -->
  @if (dualSources && !isCreditFreezeAndNonExemptedMCInConsumerReport() && isEbvsidRequired()) {
    <div class="report-section" >
      <h2>{{ 'content.dual-source-section' | translate }}</h2>
      @if (isDs04Empty()) {
        <div>
          <div>{{ 'content.dual-source-section-empty' | translate}}</div>
        </div>
      }
      @for (dualSource of dualSources; track dualSource; let i = $index) {
        <div>
          <div class="row">
            <div class="col-3">{{ 'content.source-date' | translate }}</div>
            <div class="col-9">{{ dualSource.sourceDate }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.source-name' | translate }}</div>
            <div class="col-9">{{ dualSource.sourceName }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.verification-type' | translate }}</div>
            <div class="col-9">{{ dualSource.verificationType }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.account-number' | translate }}:</div>
            <div class="col-9">{{ dualSource.accountNumber }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.date-verified' | translate }}</div>
            <div class="col-9">{{ dualSource.dateVerified }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.input-name' | translate }}</div>
            <div class="col-9">{{ dualSource.inputNameMatch }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.last-name-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.lastNameMatch | translate}}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.lastNameMatch) | async }}{{noOrPartialMatch(dualSource.lastName)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.first-name-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.firstNameMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.firstNameMatch) | async }}{{noOrPartialMatch(dualSource.firstName)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.middle-name-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.middleNameMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.middleNameMatch) | async }}{{noOrPartialMatch(dualSource.middleName)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.civic-number-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.streetOrCivicNumMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.streetOrCivicNumMatch) | async }}{{noOrPartialMatch(dualSource.streetOrCivicNum)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.street-name-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.streetNameMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.streetNameMatch) | async }}{{noOrPartialMatch(dualSource.streetName)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.apartment-number-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.apartmentNumberMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.apartmentNumberMatch) | async }}{{noOrPartialMatch(dualSource.apartmentNumber)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.city-name-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.cityNameMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.cityNameMatch ) | async }}{{noOrPartialMatch(dualSource.cityName )}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.province-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.provinceMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.provinceMatch) | async }}{{noOrPartialMatch(dualSource.province)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.postal-code-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.postalCodeMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.postalCodeMatch ) | async }}{{noOrPartialMatch(dualSource.postalCode)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.telephone-number-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.telephoneNumberMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.telephoneNumberMatch) | async }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.dob-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.dateOfBirthMatch }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.dateOfBirthMatch) | async }}{{noOrPartialMatch(dualSource.dateofBirth)}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.SIN-match-flag' | translate }}</div>
            <div class="col-9">
              <div class="row">
                <div class="col-1">{{ dualSource.sin }}</div>
                <div class="col-11">{{ amlFlagTranslation(dualSource.sin) | async }}</div>
              </div>
            </div>
          </div>
          @if (i !== (dualSources.length-1)) {
            <div>
              <hr>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (ifsReport?.avs) {
      <div class="report-section">
        <h2>{{ 'content.avs-section' | translate }}</h2>
        <div class="row">
          <div class="col-3">{{ 'content.address.creditcard-number' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchCard }}</div>
              <div class="col-11">{{ ifsReport.avs.matchCardMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.person.last-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchLName }}</div>
              <div class="col-11">{{ ifsReport.avs.matchLNameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.person.first-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchFName }}</div>
              <div class="col-11">{{ ifsReport.avs.matchFNameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.person.middle-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchMName }}</div>
              <div class="col-11">{{ ifsReport.avs.matchMNameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.person.dob' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchDob }}</div>
              <div class="col-11">{{ ifsReport.avs.matchDobMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.street-civic' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchCivic }}</div>
              <div class="col-11">{{ ifsReport.avs.matchCivicMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.street-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchStreet }}</div>
              <div class="col-11">{{ ifsReport.avs.matchStreetMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.apartment' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchApt }}</div>
              <div class="col-11">{{ ifsReport.avs.matchAptMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.city-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchCity }}</div>
              <div class="col-11">{{ ifsReport.avs.matchCityMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.province' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchProv }}</div>
              <div class="col-11">{{ ifsReport.avs.matchProvMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.postal' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchPostal }}</div>
              <div class="col-11">{{ ifsReport.avs.matchPostalMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.telephone' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchPhone }}</div>
              <div class="col-11">{{ ifsReport.avs.matchPhoneMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.velocity-check' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.ccVelocityCheck }}</div>
              <div class="col-11">{{ ifsReport.avs.ccVelocityCheckMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.social-insurance-number-short' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchLast4DigitsSin }}</div>
              <div class="col-11">{{ ifsReport.avs.matchLast4DigitsSinMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.fraud-alert' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.avs.matchHKOnFile }}</div>
              <div class="col-11">{{ ifsReport.avs.matchHKOnFileMessage }}</div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (ifsReport?.bvs) {
      <div class="report-section">
        <h2>{{ 'content.bvs-section' | translate }}</h2>
        <div class="row">
          <div class="col-3">{{ 'content.bureau-hit' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.hit }}</div>
              <div class="col-11">{{ amlBureauHitFlagTranslation(ifsReport.bvs.hit) | async }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.person.last-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchLastName }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchLastNameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.person.first-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchFirstName }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchFirstNameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.person.middle-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchMiddleName }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchMiddleNameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.person.dob' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchDob }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchDobMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.civic' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchCivic }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchCivicMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.street-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchStreet }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchStreetMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.apartment' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchApt }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchAptMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.city-name' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchCity }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchCityMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.province' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchProv }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchProvMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address.postal' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchPostal }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchPostalMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.telephone' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchPhone }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchPhoneMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.social-insurance-number-short' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.matchLast4DigitsSin }}</div>
              <div class="col-11">{{ ifsReport.bvs.matchLast4DigitsSinMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.fraud-alert' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.bvs.mHKOnFile }}</div>
              <div class="col-11">{{ ifsReport.bvs.mHKOnFileMessage }}</div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (isHrfaClear(ifsReport?.hawk)) {
      <div class="report-section">
        <h2>{{ 'content.hrfa-section' | translate }}</h2>
        <div class="row">
          <div class="col-12 col-lg-3">
            <div>{{ 'content.high-risk-fraud-alert' | translate }}</div>
          </div>
          <div class="col-12 col-lg-9">
            <div>{{ 'content.clear' | translate }}</div>
          </div>
        </div>
      </div>
    }
    @if (hasHrfa(ifsReport?.hawk)) {
      <div class="report-section">
        <h2>{{ 'content.hrfa-section' | translate }}</h2>
        @for (hrfa of hrfa(ifsReport?.hawk) | keyvalue; track hrfa) {
          <div class="row">
            <div class="col-12 col-lg-3">
              <div>{{ hrfa.key }}</div>
            </div>
            <div class="col-12 col-lg-9">
              <div>{{ hrfa.value }}</div>
            </div>
          </div>
        }
      </div>
    }
    @if (ifsReport?.dirs) {
      <div class="report-section">
        <h2>{{ 'content.directory-services' | translate }}</h2>
        @if (isNoHit(ifsReport?.dirs)) {
          <div>
            <div class="row">
              <div class="col-3">{{ 'content.phone.number-not-found' | translate }}</div>
            </div>
          </div>
        }
        @if (!isNoHit(ifsReport?.dirs)) {
          <div>
            <div class="row">
              <div class="col-3">{{ 'content.person.last-name' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.lastName }}</div>
            </div>
            <div class="row">
              <div class="col-3">{{ 'content.person.first-name' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.firstName }}</div>
            </div>
            <div class="row">
              <div class="col-3">{{ 'content.person.middle-name' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.middleName }}</div>
            </div>
            <div class="row">
              <div class="col-3">{{ 'content.address.street' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.street }}</div>
            </div>
            <div class="row">
              <div class="col-3">{{ 'content.address.civic' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.civic }}</div>
            </div>
            <div class="row">
              <div class="col-3">{{ 'content.address.apartment' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.apt }}</div>
            </div>
            <div class="row">
              <div class="col-3">{{ 'content.address.city' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.city }}</div>
            </div>
            <div class="row">
              <div class="col-3">{{ 'content.address.province-short' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.prov }}</div>
            </div>
            <div class="row">
              <div class="col-3">{{ 'content.address.postal' | translate }}:</div>
              <div class="col-9">{{ ifsReport.dirs.postal }}</div>
            </div>
            @if (!isReportAnyIfsProduct(['dirsLookup', 'eDirs'])) {
              <div class="row">
                <div class="col-3">{{ 'content.telephone' | translate }}:</div>
                <div class="col-9">{{ reformatPhone(ifsReport.dirs.phone) }}</div>
              </div>
            }
            <div class="row">
              <div class="col-3">{{ 'content.months-on-file' | translate }}:</div>
              <div class="col-9">{{ ifsReport?.dirs2?.monthsOnFile || '' }}</div>
            </div>
          </div>
        }
      </div>
    }
    @if (ifsReport?.dirs && !isNoHit(ifsReport?.dirs)) {
      <div class="report-section">
        <div class="row">
          <div class="col-3">{{ 'content.name-match-flag' | translate }}:</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchName }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchNameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.address-match-flag' | translate }}:</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchAddress }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchAddressMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.phone-match-flag' | translate }}:</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchPhone }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchPhoneMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.last-name-match-flag' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchLname }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchLnameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.first-name-match-flag' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchFname }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchFnameMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.street-name-match-flag' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchStreet }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchStreetMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.civic-number-match-flag' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchCivic }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchCivicMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.apartment-number-match-flag' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchApt }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchAptMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.city-name-match-flag' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchCity }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchCityMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.province-match-flag' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchProv }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchProvMessage }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">{{ 'content.postal-code-match-flag' | translate }}</div>
          <div class="col-9">
            <div class="row">
              <div class="col-1">{{ ifsReport.dirs.matchPostal }}</div>
              <div class="col-11">{{ ifsReport.dirs.matchPostalMessage }}</div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
